import _ from "lodash";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import locales from "../../../_constants/locales";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemText from "@material-ui/core/ListItemText";
import ConfirmationWindow from "./_ConfirmationWindow";
import DataConflictWindow from "./_DataConflictWindow";
import FormHelperText from "@material-ui/core/FormHelperText";
import "../Styles/_CancelOrderItemsWindow.css";

let order_details_scroll_event_added = false;
let scrolled_into_view = false;

let isInViewport = (element, box_element) => {
    let element_bounding = element.getBoundingClientRect();
    let box_element_bounding = box_element.getBoundingClientRect();

    return Math.round(element_bounding.top) < Math.round(box_element_bounding.bottom);
};

const getItemPicture = sku => {
    return `https://static.koboscm.com/images/RakutenKobo/devices/${sku}.png`;
};

class CancelOrderItemsWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allocatedCancelItems: [],
            cancelReasonId: null,
            cancelErrorMessage: "",
            itemsAvailableForCancellation: [],
            cancelFinished: false,
            submitErrors: [],
            scrolling: false,
            confirmationWindowOpen: false,
            dataConflictWindowOpen: false
        };
    }

    checkScrollingScroll = () => {
        window.requestAnimationFrame(() => {
            if (
                document.getElementById("sticky-refund-total") &&
                document.getElementById("cancel-window-calculation-summary") &&
                isInViewport(document.getElementById("sticky-refund-total"), document.getElementById("cancel-window-calculation-summary"))
            ) {
                if (!this.state.scrolling) {
                    this.setState({
                        scrolling: true
                    });
                }
            } else {
                if (this.state.scrolling) {
                    this.setState({
                        scrolling: false
                    });
                }
            }
        });
    };

    checkScrollingResize = () => {
        window.requestAnimationFrame(() => {
            if (
                document.getElementById("sticky-refund-total") &&
                document.getElementById("cancel-window-calculation-summary") &&
                isInViewport(document.getElementById("sticky-refund-total"), document.getElementById("cancel-window-calculation-summary"))
            ) {
                if (!this.state.scrolling) {
                    this.setState({
                        scrolling: true
                    });
                }
            } else {
                if (this.state.scrolling) {
                    this.setState({
                        scrolling: false
                    });
                }
            }
        });
    };

    componentWillMount() {
        scrolled_into_view = false;
    }

    componentWillUnmount() {
        this.removeEventListeners();
    }

    componentDidMount() {
        let itemsAvailableForCancellation = [];

        this.props.order.sub_orders.forEach(so => {
            so.line_items.forEach(line_item => {
                if (line_item.fulfillable_quantity !== 0) {
                    let lineItem = Object.assign({}, line_item);
                    lineItem.fulfillable_quantity = line_item.fulfillable_quantity;

                    itemsAvailableForCancellation.push(lineItem);
                }
            });
        });

        this.props.order.line_items
            .filter(li => li.requires_shipping === false)
            .filter(li => !li.sku.includes("EGIFTCARD"))
            .forEach(line_item => {
                let refundedProtectionLineItem = this.props.order.refunded_items.filter(
                    refundedItem => refundedItem.requires_shipping === false && line_item.id === refundedItem.id
                )[0];
                let lineItem = Object.assign({}, line_item);

                if (refundedProtectionLineItem) {
                    if (line_item.quantity - refundedProtectionLineItem.quantity > 0) {
                        lineItem.fulfillable_quantity = line_item.quantity - refundedProtectionLineItem.quantity;
                        itemsAvailableForCancellation.push(lineItem);
                    }
                } else {
                    lineItem.fulfillable_quantity = line_item.quantity;
                    itemsAvailableForCancellation.push(lineItem);
                }
            });

        this.setState({
            itemsAvailableForCancellation
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.loading === false && prevProps.loading === true) {
            if (!this.props.err) {
                this.setState({
                    cancelFinished: true
                });
            } else {
                this.setState({
                    cancelErrorMessage: locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS.ERROR_FAILED
                });
            }
        }

        if (this.props.cancelOrderCalculating === false && prevProps.cancelOrderCalculating === true) {
            if (this.props.cancelOrderCalculatingError) {
                this.setState({
                    cancelErrorMessage: locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS.ERROR_CALCULATION_FAILED
                });
            } else {
                this.resetErrorMessages();
            }

            this.checkScrollingForRefundTotal();
            this.addEventListeners();
        }

        if (
            (prevProps.cancelOrderCalculating === true &&
                this.props.cancelOrderCalculating === false &&
                this.props.cancelOrderCalculatingError === "conflict") ||
            (prevProps.loading === true && this.props.loading === false && this.props.err === "conflict")
        ) {
            this.setState({
                dataConflictWindowOpen: true
            });
        }

        if (prevProps.open === false && this.props.open === true && this.props.cancelReasons.length === 0 && this.props.cancelReasonsLoading === false) {
            this.props.getCancelReasons();
        }

        if (prevProps.open === false && this.props.open === true) {
            this.resetErrorMessages();
            this.resetCancelReason();
            this.resetCancelItems();
            this.resetCancelFinished();
            this.props.cancelOrderCalculateReset();
            this.resetSubmitErrors();
            scrolled_into_view = false;
        }

        if (JSON.stringify(prevState.allocatedCancelItems) !== JSON.stringify(this.state.allocatedCancelItems)) {
            this.props.cancelOrderCalculate(this.props.match.params.order_id, {
                order: this.props.order,
                items: this.state.allocatedCancelItems.map(i => ({ lineItemId: i.line_item_id, quantity: Number(i.quantity) }))
            });
        }

        this.scrollWindowIntoView();
    }

    scrollWindowIntoView() {
        var element = document.getElementById("order-items-cancellation-window");

        if (element && !scrolled_into_view) {
            element.scrollIntoView({
                behavior: "auto",
                block: "center",
                inline: "center"
            });
            scrolled_into_view = true;

            this.postMessageToParentWindow();
        }
    }

    postMessageToParentWindow() {
        let data = {
            action: "DIALOG_WINDOW_OPEN"
        };

        window.parent.window.postMessage(JSON.stringify(data), "*");
    }

    resetCancelFinished() {
        this.setState({
            cancelFinished: false
        });
    }

    handleNoClick() {
        this.removeEventListeners();
        if (this.state.cancelFinished) {
            this.props.handleClose();
            this.props.getOrder(this.props.order_id);
        } else {
            this.props.handleClose();
        }
    }

    handleYesClick() {
        this.resetSubmitErrors();
        if (this.getSubmitErrors().length === 0) {
            this.handleOpenConfirmationWindow();
        } else {
            this.updateSubmitErrors();
        }
    }

    updateSubmitErrors() {
        this.setState({
            submitErrors: this.getSubmitErrors()
        });
    }

    handleConfirmCancelOrder() {
        this.resetErrorMessages();
        this.handleCloseConfirmationWindow();
        this.cancelOrder();
    }

    cancelOrder() {
        this.props.cancelOrder(this.props.order_id, {
            order: this.props.order,
            items: this.state.allocatedCancelItems.map(i => ({ lineItemId: i.line_item_id, quantity: Number(i.quantity) })),
            reason: this.state.cancelReasonId
        });
    }

    getSubmitErrors() {
        let errors = [];

        if (!this.state.cancelReasonId) {
            errors.push({
                code: "cancel_reason",
                label: locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.ERRORS.REASON_REQUIRED
            });
        }

        if (this.state.allocatedCancelItems.length === 0) {
            errors.push({
                code: "cancel_items",
                label: locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS.ERRORS.CANCEL_ITEMS_REQUIRED
            });
        }

        return errors;
    }

    resetSubmitErrors() {
        this.setState({
            submitErrors: []
        });
    }

    resetErrorMessages() {
        this.setState({
            cancelErrorMessage: ""
        });
    }

    handleEnter() {
        this.resetErrorMessages();
        // this.SetBodyScroll();
    }

    SetBodyScroll() {
        let el = document.getElementById("body");

        if (el.style.overflow === "hidden") {
            el.style.overflow = "initial";
        }
    }

    handleCancelItemRemoveClick(lineItem) {
        let allocatedCancelItem = this.getAllocatedCancelItem(lineItem, this.state.allocatedCancelItems);
        if (allocatedCancelItem) {
            this.handleCancelItemQuantityChangeByValue(lineItem, allocatedCancelItem.quantity - 1);
        }
    }

    handleCancelItemAddClick(lineItem) {
        let allocatedCancelItem = this.getAllocatedCancelItem(lineItem, this.state.allocatedCancelItems);
        if (allocatedCancelItem) {
            this.handleCancelItemQuantityChangeByValue(lineItem, allocatedCancelItem.quantity + 1);
        } else {
            this.handleCancelItemQuantityChangeByValue(lineItem, 1);
        }
    }

    handleCancelItemQuantityChange(lineItem, e) {
        if (!this.props.cancelOrderCalculating && !this.props.loading && !isNaN(e.target.value) && Number(e.target.value) >= 0) {
            let value = Number(e.target.value);

            this.handleCancelItemQuantityChangeByValue(lineItem, value);
        }
    }

    getAllocatedReferenceItemByProtectionItem(protectionCancelItem) {
        return this.state.allocatedCancelItems.filter(allocatedCancelItem =>
            this.state.itemsAvailableForCancellation.some(
                itemAvailableForCancellation =>
                    !itemAvailableForCancellation.requires_shipping === false &&
                    protectionCancelItem.properties.some(
                        property =>
                            property.name === "Reference" &&
                            property.value === itemAvailableForCancellation.variant_id.toString() &&
                            itemAvailableForCancellation.line_item_id === allocatedCancelItem.line_item_id
                    )
            )
        )[0];
    }

    getAvailableCancelItemsByCancelItems(cancelItems) {
        return this.state.itemsAvailableForCancellation.filter(itemAvailableForCancellation =>
            cancelItems.some(cancelItem => cancelItem.line_item_id === itemAvailableForCancellation.line_item_id)
        );
    }

    getAllocatedProtectionCancelItemsByReferenceCancelItem(referenceCancelItem, allocatedCancelItems) {
        let items = this.getAvailableCancelItemsByCancelItems(allocatedCancelItems);
        let protectionCancelItems = items.filter(
            li =>
                li.requires_shipping === false &&
                li.properties &&
                li.properties.some(p => p.name === "Reference" && p.value === referenceCancelItem.variant_id.toString())
        );

        return allocatedCancelItems.filter(allocatedCancelItem =>
            protectionCancelItems.some(protectionCancelItem => protectionCancelItem.line_item_id === allocatedCancelItem.line_item_id)
        );
    }

    getAllocatedCancelItem(item, allocatedCancelItems) {
        return allocatedCancelItems.filter(allocatedCancelItem => allocatedCancelItem.line_item_id === item.line_item_id)[0];
    }

    getUpdatedAllocatedCancelItemsAfterRemovingItem(allocatedCancelItems, item) {
        return allocatedCancelItems.filter(allocatedCancelItem => allocatedCancelItem.line_item_id !== item.line_item_id);
    }

    getAvailableItem(item) {
        return this.state.itemsAvailableForCancellation.filter(
            itemAvailableForCancellation => itemAvailableForCancellation.line_item_id === item.line_item_id
        )[0];
    }

    getAvailableProtectionItemsByReferenceItem(referenceItem) {
        return this.state.itemsAvailableForCancellation.filter(
            itemAvailableForCancellation =>
                itemAvailableForCancellation.requires_shipping === false &&
                itemAvailableForCancellation.properties &&
                itemAvailableForCancellation.properties.some(
                    property => property.name === "Reference" && property.value === referenceItem.variant_id.toString()
                )
        );
    }

    getTotalProtectionItemsQuantity(referenceItem) {
        let avaliableProtectionItems = this.getAvailableProtectionItemsByReferenceItem(referenceItem);

        return avaliableProtectionItems.reduce((prev, current) => {
            return parseInt(prev) + parseInt(current.fulfillable_quantity);
        }, 0);
    }

    getThresholdQuantity(referenceItem) {
        return referenceItem.fulfillable_quantity - this.getTotalProtectionItemsQuantity(referenceItem);
    }

    getAllocatedProtectionCancelItems(referenceItem, allocatedCancelItems) {
        let avaliableProtectionItems = this.getAvailableProtectionItemsByReferenceItem(referenceItem);

        return allocatedCancelItems.filter(allocatedCancelItem =>
            avaliableProtectionItems.some(avaliableProtectionItem => avaliableProtectionItem.line_item_id === allocatedCancelItem.line_item_id)
        );
    }

    getTotalAllocatedProtectionCancelItemsQuantityAfterUpdate(allocatedProtectionCancelItems, allocatedProtectionCancelItem, newQuantity) {
        let allocatedProtectionItemsCopy = JSON.parse(JSON.stringify(allocatedProtectionCancelItems));

        allocatedProtectionItemsCopy.filter(
            allocatedProtectionItem => allocatedProtectionItem.line_item_id === allocatedProtectionCancelItem.line_item_id
        )[0].quantity = newQuantity;

        return allocatedProtectionItemsCopy.reduce((prev, current) => {
            return parseInt(prev) + parseInt(current.quantity);
        }, 0);
    }

    getAvailableProtectionCancelItems(referenceItem) {
        return this.state.itemsAvailableForCancellation.filter(
            itemAvailableForCancellation =>
                itemAvailableForCancellation.requires_shipping === false &&
                itemAvailableForCancellation.properties &&
                itemAvailableForCancellation.properties.some(
                    property => property.name === "Reference" && property.value === referenceItem.variant_id.toString()
                )
        );
    }

    getTotalAllocatedProtectionCancelItemsQuantity(allocatedProtectionItems) {
        return allocatedProtectionItems.reduce((prev, current) => {
            return parseInt(prev) + parseInt(current.quantity);
        }, 0);
    }

    handleCancelItemQuantityChangeByValue(lineItem, newValue) {
        if (!this.props.cancelOrderCalculating && !this.props.loading && !isNaN(newValue) && Number(newValue) >= 0) {
            let allocatedCancelItems = JSON.parse(JSON.stringify(this.state.allocatedCancelItems));
            let allocatedCancelItem = this.getAllocatedCancelItem(lineItem, allocatedCancelItems);

            // if item is already in the refund items list
            if (allocatedCancelItem) {
                if (Number(newValue) === 0) {
                    // only remove item from the refund items list if there are no reference items
                    if (lineItem.requires_shipping === false) {
                        let allocatedReferenceCancelItem = this.getAllocatedReferenceItemByProtectionItem(lineItem);

                        if (allocatedReferenceCancelItem) {
                            let referenceItem = this.getAvailableItem(allocatedReferenceCancelItem);

                            let thresholdQuantity = this.getThresholdQuantity(referenceItem);

                            let allocatedProtectionCancelItems = this.getAllocatedProtectionCancelItems(referenceItem, allocatedCancelItems);

                            let totalAllocatedProtectionItemsQuantityAfterUpdate = this.getTotalAllocatedProtectionCancelItemsQuantityAfterUpdate(
                                allocatedProtectionCancelItems,
                                allocatedCancelItem,
                                Number(newValue)
                            );

                            if (totalAllocatedProtectionItemsQuantityAfterUpdate >= allocatedReferenceCancelItem.quantity - thresholdQuantity) {
                                //remove
                                allocatedCancelItems = this.getUpdatedAllocatedCancelItemsAfterRemovingItem(allocatedCancelItems, lineItem);
                            }
                        } else {
                            //remove
                            allocatedCancelItems = this.getUpdatedAllocatedCancelItemsAfterRemovingItem(allocatedCancelItems, lineItem);
                        }
                    } else {
                        //remove
                        allocatedCancelItems = this.getUpdatedAllocatedCancelItemsAfterRemovingItem(allocatedCancelItems, lineItem);
                    }
                } else {
                    if (lineItem.requires_shipping === false) {
                        let allocatedReferenceCancelItem = this.getAllocatedReferenceItemByProtectionItem(lineItem);

                        if (allocatedReferenceCancelItem) {
                            let referenceItem = this.getAvailableItem(allocatedReferenceCancelItem);

                            let allocatedProtectionCancelItems = this.getAllocatedProtectionCancelItemsByReferenceCancelItem(
                                referenceItem,
                                allocatedCancelItems
                            );

                            let thresholdQuantity = this.getThresholdQuantity(referenceItem);

                            let totalAllocatedProtectionItemsQuantityAfterUpdate = this.getTotalAllocatedProtectionCancelItemsQuantityAfterUpdate(
                                allocatedProtectionCancelItems,
                                allocatedCancelItem,
                                Number(newValue)
                            );

                            if (totalAllocatedProtectionItemsQuantityAfterUpdate >= allocatedReferenceCancelItem.quantity - thresholdQuantity) {
                                // update quantity
                                allocatedCancelItem.quantity =
                                    Number(newValue) < lineItem.fulfillable_quantity ? Number(newValue) : lineItem.fulfillable_quantity;
                            }
                        } else {
                            // update quantity
                            allocatedCancelItem.quantity = Number(newValue) < lineItem.fulfillable_quantity ? Number(newValue) : lineItem.fulfillable_quantity;
                        }
                    } else {
                        // update quantity
                        allocatedCancelItem.quantity = Number(newValue) < lineItem.fulfillable_quantity ? Number(newValue) : lineItem.fulfillable_quantity;

                        let referenceItem = this.getAvailableItem(allocatedCancelItem);
                        let availableProtectionCancelItems = this.getAvailableProtectionCancelItems(referenceItem);

                        if (availableProtectionCancelItems) {
                            let thresholdQuantity = this.getThresholdQuantity(referenceItem);

                            let quantityToAllocate = allocatedCancelItem.quantity - thresholdQuantity;

                            if (quantityToAllocate > 0) {
                                let allocatedProtectionCancelItems = this.getAllocatedProtectionCancelItemsByReferenceCancelItem(
                                    lineItem,
                                    allocatedCancelItems
                                );

                                if (allocatedProtectionCancelItems) {
                                    let totalAllocatedProtectionCancelItemsQuantity =
                                        this.getTotalAllocatedProtectionCancelItemsQuantity(allocatedProtectionCancelItems);

                                    quantityToAllocate = quantityToAllocate - totalAllocatedProtectionCancelItemsQuantity;

                                    if (quantityToAllocate > 0) {
                                        _.orderBy(allocatedProtectionCancelItems, ["price"], ["desc"]).forEach(allocatedProtectionLineItem => {
                                            if (quantityToAllocate === 0) {
                                                return;
                                            }

                                            let avaliableProtectionCancelItem = this.getAvailableItem(allocatedProtectionLineItem);

                                            if (avaliableProtectionCancelItem.fulfillable_quantity - allocatedProtectionLineItem.quantity > 0) {
                                                let maximumQuantityToAdd =
                                                    avaliableProtectionCancelItem.fulfillable_quantity - allocatedProtectionLineItem.quantity;

                                                if (maximumQuantityToAdd > 0) {
                                                    let quantityToAdd = maximumQuantityToAdd > quantityToAllocate ? quantityToAllocate : maximumQuantityToAdd;

                                                    allocatedProtectionLineItem.quantity = Number(allocatedProtectionLineItem.quantity) + Number(quantityToAdd);

                                                    quantityToAllocate = quantityToAllocate - quantityToAdd;
                                                }
                                            }
                                        });
                                    }
                                }

                                if (quantityToAllocate > 0) {
                                    let availableProtectionCancelItems = this.getAvailableProtectionCancelItems(referenceItem).filter(
                                        itemAvailableForCAncellation =>
                                            !allocatedProtectionCancelItems.some(li => li.line_item_id === itemAvailableForCAncellation.line_item_id) // not already allocated
                                    );

                                    if (availableProtectionCancelItems) {
                                        _.orderBy(availableProtectionCancelItems, ["price"], ["desc"]).forEach(availableProtectionLineItem => {
                                            if (quantityToAllocate === 0) {
                                                return;
                                            }

                                            let protectionLineItem = this.state.itemsAvailableForCancellation.filter(
                                                i => i.line_item_id === availableProtectionLineItem.line_item_id
                                            )[0];

                                            let maximumQuantityToAssign = protectionLineItem.fulfillable_quantity;

                                            let quantityToAssign = maximumQuantityToAssign > quantityToAllocate ? quantityToAllocate : maximumQuantityToAssign;

                                            let newAllocatedCancelItem = {
                                                line_item_id: availableProtectionLineItem.line_item_id,
                                                quantity: quantityToAssign
                                            };

                                            allocatedCancelItems.push(newAllocatedCancelItem);

                                            quantityToAllocate = quantityToAllocate - quantityToAssign;
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                if (Number(newValue) !== 0) {
                    let newQuantity = newValue < lineItem.fulfillable_quantity ? newValue : lineItem.fulfillable_quantity;

                    let newCancelItem = {
                        line_item_id: lineItem.line_item_id,
                        quantity: newQuantity
                    };

                    // add item to allocated refund items list
                    allocatedCancelItems.push(newCancelItem);

                    if (lineItem.requires_shipping === false) {
                    } else {
                        let protectionItems = this.getAvailableProtectionItemsByReferenceItem(lineItem);

                        if (protectionItems) {
                            let thresholdQuantity = this.getThresholdQuantity(lineItem);

                            if (newQuantity > thresholdQuantity) {
                                let quantityToAllocate = newCancelItem.quantity - thresholdQuantity;

                                if (quantityToAllocate > 0) {
                                    let allocatedProtectionCancelItems = this.getAllocatedProtectionCancelItemsByReferenceCancelItem(
                                        lineItem,
                                        allocatedCancelItems
                                    );

                                    if (allocatedProtectionCancelItems) {
                                        let totalAllocatedProtectionCancelItemsQuantity =
                                            this.getTotalAllocatedProtectionCancelItemsQuantity(allocatedProtectionCancelItems);

                                        quantityToAllocate = quantityToAllocate - totalAllocatedProtectionCancelItemsQuantity;

                                        if (quantityToAllocate > 0) {
                                            _.orderBy(allocatedProtectionCancelItems, ["price"], ["desc"]).forEach(allocatedProtectionLineItem => {
                                                if (quantityToAllocate === 0) {
                                                    return;
                                                }

                                                let avaliableProtectionCancelItem = this.getAvailableItem(allocatedProtectionLineItem);

                                                if (avaliableProtectionCancelItem.fulfillable_quantity - allocatedProtectionLineItem.quantity > 0) {
                                                    let maximumQuantityToAdd =
                                                        avaliableProtectionCancelItem.fulfillable_quantity - allocatedProtectionLineItem.quantity;

                                                    if (maximumQuantityToAdd > 0) {
                                                        let quantityToAdd =
                                                            maximumQuantityToAdd > quantityToAllocate ? quantityToAllocate : maximumQuantityToAdd;

                                                        allocatedProtectionLineItem.quantity =
                                                            Number(allocatedProtectionLineItem.quantity) + Number(quantityToAdd);

                                                        quantityToAllocate = quantityToAllocate - quantityToAdd;
                                                    }
                                                }
                                            });
                                        }
                                    }

                                    if (quantityToAllocate > 0) {
                                        let availableProtectionCancelItems = this.getAvailableProtectionCancelItems(lineItem).filter(
                                            itemAvailableForCAncellation =>
                                                !allocatedProtectionCancelItems.some(li => li.line_item_id === itemAvailableForCAncellation.line_item_id) // not already allocated
                                        );

                                        if (availableProtectionCancelItems) {
                                            _.orderBy(availableProtectionCancelItems, ["price"], ["desc"]).forEach(availableProtectionLineItem => {
                                                if (quantityToAllocate === 0) {
                                                    return;
                                                }

                                                let protectionLineItem = this.state.itemsAvailableForCancellation.filter(
                                                    i => i.line_item_id === availableProtectionLineItem.line_item_id
                                                )[0];

                                                let maximumQuantityToAssign = protectionLineItem.fulfillable_quantity;

                                                let quantityToAssign =
                                                    maximumQuantityToAssign > quantityToAllocate ? quantityToAllocate : maximumQuantityToAssign;

                                                let newAllocatedCancelItem = {
                                                    line_item_id: availableProtectionLineItem.line_item_id,
                                                    quantity: quantityToAssign
                                                };

                                                allocatedCancelItems.push(newAllocatedCancelItem);

                                                quantityToAllocate = quantityToAllocate - quantityToAssign;
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            this.setState({
                allocatedCancelItems: allocatedCancelItems
            });
        }
    }

    handleChange(e) {
        switch (e.target.name) {
            case "cancel-reason":
                this.setState({
                    cancelReasonId: e.target.value
                });
                break;

            default:
                break;
        }
    }

    resetCancelReason() {
        this.setState({
            cancelReasonId: null
        });
    }

    resetCancelItems() {
        this.setState({
            allocatedCancelItems: []
        });
    }

    handleSelectAllClick() {
        let allocatedCancelItems = [];

        this.state.itemsAvailableForCancellation.map(lineItem => {
            allocatedCancelItems.push({
                line_item_id: lineItem.line_item_id,
                quantity: lineItem.fulfillable_quantity
            });
        });

        this.setState({
            allocatedCancelItems: JSON.parse(JSON.stringify(allocatedCancelItems))
        });
    }

    selectAllEnabled() {
        return !this.state.itemsAvailableForCancellation.every(lineItem =>
            this.state.allocatedCancelItems.some(
                cancelItem => lineItem.line_item_id === cancelItem.line_item_id && lineItem.fulfillable_quantity === cancelItem.quantity
            )
        );
    }

    handleCloseConfirmationWindow() {
        this.removeEventListeners();
        this.setState({
            confirmationWindowOpen: false
        });
    }

    handleOpenConfirmationWindow() {
        this.setState({
            confirmationWindowOpen: true
        });
    }

    handleRefreshOrder() {
        this.props.handleClose();
        this.props.refreshOrder();
    }

    addEventListeners() {
        let elements = document.getElementsByClassName("order-cancellation-dialog-paper");

        if (elements[0]) {
            if (document.getElementById("sticky-refund-total") && document.getElementById("cancel-window-calculation-summary")) {
                elements[0].addEventListener("scroll", this.checkScrollingScroll);
                window.addEventListener("resize", this.checkScrollingResize);
                order_details_scroll_event_added = true;
            }
        }
    }

    removeEventListeners() {
        let elements = document.getElementsByClassName("order-cancellation-dialog-paper");
        if (elements[0]) {
            elements[0].removeEventListener("scroll", this.checkScrollingScroll);
        }

        window.removeEventListener("resize", this.checkScrollingResize);

        order_details_scroll_event_added = false;
    }

    checkScrollingForRefundTotal() {
        if (isInViewport(document.getElementById("sticky-refund-total"), document.getElementById("cancel-window-calculation-summary"))) {
            if (!this.state.scrolling) {
                this.setState({
                    scrolling: true
                });
            }
        } else {
            if (this.state.scrolling) {
                this.setState({
                    scrolling: false
                });
            }
        }
    }

    getFilterProtectionLineItemName(protectionLineItem) {
        let firstPart = protectionLineItem.name.slice(0, protectionLineItem.name.indexOf("-")).replace("Clyde", "");
        let secondPart = "";

        if (protectionLineItem.properties && protectionLineItem.properties.some(p => p.name === "Reference")) {
            let referenceItem = this.props.order.line_items.filter(
                li => li.requires_shipping === true && li.variant_id.toString() === protectionLineItem.properties.filter(p => p.name === "Reference")[0].value
            )[0];

            secondPart = referenceItem.name;
        }

        return `${firstPart} - ${secondPart}`;
    }

    getFilterProtectionLineItemYear(protectionLineItem) {
        let yearsCoverage = protectionLineItem.name.substring(protectionLineItem.name.indexOf("/") + 1);

        return yearsCoverage;
    }

    getFilteredLineItemName(lineItem) {
        if (lineItem.requires_shipping === false) {
            return `${this.getFilterProtectionLineItemName(lineItem)} - ${this.getFilterProtectionLineItemYear(lineItem)}`;
        } else {
            return `${lineItem.title}${lineItem.variant_title ? ` - ${lineItem.variant_title}` : ""}`;
        }
    }

    handleCancelItemRemoveEnabled(lineItem) {
        return this.state.allocatedCancelItems.filter(i => i.line_item_id === lineItem.line_item_id)[0];
    }

    handleCancelItemAddEnabled(lineItem) {
        return !(
            this.state.allocatedCancelItems.filter(i => i.line_item_id === lineItem.line_item_id)[0] &&
            this.state.allocatedCancelItems.filter(i => i.line_item_id === lineItem.line_item_id)[0].quantity === lineItem.fulfillable_quantity
        );
    }

    getCanceItemSelectedQuantity(lineItem) {
        return this.state.allocatedCancelItems.filter(i => i.line_item_id === lineItem.line_item_id)[0]
            ? this.state.allocatedCancelItems.filter(i => i.line_item_id === lineItem.line_item_id)[0].quantity
            : "";
    }

    sortItems(items) {
        let sortedItems = [];

        let itemsCopy = JSON.parse(JSON.stringify(items));

        itemsCopy.forEach(item => {
            item.price = parseFloat(item.price);
        });

        itemsCopy = _.orderBy(itemsCopy, ["price", "sku"], ["desc", "asc"]);

        itemsCopy.forEach(item => {
            if (item.requires_shipping === true) {
                sortedItems.push(item);

                let protectionItems = itemsCopy.filter(
                    i => i.title.includes("Protection") && i.properties.some(p => p.name === "Reference" && p.value === item.variant_id.toString())
                );

                if (protectionItems) {
                    sortedItems = sortedItems.concat(protectionItems);
                }
            }
        });

        return sortedItems;
    }

    sortModifiedItems(items) {
        let normalSortedList = this.sortItems(this.props.order.line_items);
        let sortedItems = [];
        let itemsCopy = JSON.parse(JSON.stringify(items));
        itemsCopy.forEach(item => {
            item.price = parseFloat(item.price);
        });

        normalSortedList.forEach(normalSorteditem => {
            var item = items.filter(i => i.id === normalSorteditem.id)[0];
            if (item) {
                sortedItems.push(item);
            }
        });

        return sortedItems;
    }

    render() {
        return (
            <Dialog
                classes={{ paper: `order-items-cancellation-dialog-paper${this.state.cancelFinished ? " completed" : ""}` }}
                className="order-cancellation-dialog"
                disableBackdropClick
                disableEscapeKeyDown
                // aria-labelledby="simple-dialog-title"
                open={this.props.open || false}
                onEnter={this.handleEnter.bind(this)}
            >
                <div
                    id="order-items-cancellation-window"
                    className={`layout vertical order-items-cancellation-window relative${this.state.cancelFinished ? " completed" : ""}`}
                >
                    <div className="order-items-cancellation-window-inner">
                        {(this.state.confirmationWindowOpen || this.state.dataConflictWindowOpen) && <div className="fit layout vertical backdrop-1" />}
                        <div
                            className={`loading-box fit layout vertical center-center${
                                !(this.props.loading || this.props.cancelOrderCalculating || this.props.cancelReasonsLoading) ? " hidden" : ""
                            }`}
                        >
                            <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                        </div>

                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <p className="title">
                                        {locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS.HEADING}
                                    </p>
                                </div>
                            </div>
                        </div>
                        {!this.state.cancelFinished && (
                            <div>
                                {this.state.cancelErrorMessage && (
                                    <div className="box">
                                        <div className="row">
                                            <div className="column">
                                                <div className="message-box">{this.state.cancelErrorMessage}</div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="box">
                                    <div className="row">
                                        <div className="column">
                                            <div className="sub-title">
                                                {locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS.SUBHEADING}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="box" style={{ marginBottom: "0px" }}>
                                    <div className="row" style={{ marginBottom: "0px" }}>
                                        <div className="column">
                                            <div className="flex layout horizontal items-refund-summary">
                                                <div className="flex layout vertical">
                                                    <div className="layout horizontal justified">
                                                        <h2 className="section-title flex">
                                                            {
                                                                locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS
                                                                    .ITEMS_HEADER
                                                            }
                                                        </h2>
                                                        <div style={{ fontSize: "14px", alignSelf: "center" }}>
                                                            <a
                                                                className={`linked-text${!this.selectAllEnabled() ? " disabled" : ""}`}
                                                                onClick={this.handleSelectAllClick.bind(this)}
                                                            >
                                                                {
                                                                    locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION
                                                                        .CANCEL_ORDER_ITEMS.SELECT_ALL_ITEMS
                                                                }
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div className="layout horizontal item-list">
                                                        <table className="flex layout vertical">
                                                            <tbody className="flex layout vertical">
                                                                {this.sortModifiedItems(this.state.itemsAvailableForCancellation).map((li, i) => {
                                                                    return (
                                                                        <tr key={i} className="layout horizontal item">
                                                                            <td>
                                                                                <div className="flex cancel-order-item-image-box relative">
                                                                                    <img
                                                                                        className="cancel-order-item-image"
                                                                                        src={getItemPicture(li.sku)}
                                                                                        alt=""
                                                                                    />
                                                                                    <div className="cancel-order-item-quantity">{li.fulfillable_quantity}</div>
                                                                                </div>
                                                                            </td>
                                                                            <td className="flex cancel-order-item-description">
                                                                                <span className="layout vertical">
                                                                                    {/* <span>{li.name}</span> */}
                                                                                    <span>{this.getFilteredLineItemName(li)}</span>

                                                                                    <span>{li.price_formatted}</span>
                                                                                </span>
                                                                            </td>
                                                                            <td className="layout  cancel-item-quantity-box">
                                                                                <div className="layout horizontal center-center">
                                                                                    <Button
                                                                                        disabled={!this.handleCancelItemRemoveEnabled(li)}
                                                                                        onClick={this.handleCancelItemRemoveClick.bind(this, li)}
                                                                                        className="cancel-item-quantity-change-button"
                                                                                        color="primary"
                                                                                    >
                                                                                        <RemoveIcon />
                                                                                    </Button>
                                                                                    <TextField
                                                                                        className="cancel-item-quantity"
                                                                                        name="cancel-item-quantity"
                                                                                        value={this.getCanceItemSelectedQuantity(li)}
                                                                                        onChange={this.handleCancelItemQuantityChange.bind(this, li)}
                                                                                        autoComplete="off"
                                                                                    />
                                                                                    <Button
                                                                                        disabled={!this.handleCancelItemAddEnabled(li)}
                                                                                        onClick={this.handleCancelItemAddClick.bind(this, li)}
                                                                                        className="cancel-item-quantity-change-button"
                                                                                        color="primary"
                                                                                    >
                                                                                        <AddIcon />
                                                                                    </Button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {this.props.total_egift_cards !== null && this.props.total_egift_cards > 0 && (
                                                        <div style={{ fontSize: "11px", color: "rgba(0, 0, 0, 0.54)", margin: "5px 0px 10px 0px" }}>
                                                            {
                                                                locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS
                                                                    .EGIFTCARDS_PRESENT_MESSAGE
                                                            }
                                                        </div>
                                                    )}
                                                    {this.state.submitErrors.length > 0 && this.state.submitErrors.find(e => e.code === "cancel_items") && (
                                                        <FormHelperText className="custom-helper-text">
                                                            {this.state.submitErrors.find(e => e.code === "cancel_items").label}
                                                        </FormHelperText>
                                                    )}
                                                    <div className="cancel-reason-box">
                                                        <div className="layout vertical custom-select-box">
                                                            <InputLabel className={`custom-select-label`}>{`* ${
                                                                locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.REASON_HEADER
                                                            }`}</InputLabel>
                                                            <Select
                                                                classes={{
                                                                    selectMenu: "custom-select-menu"
                                                                }}
                                                                name="cancel-reason"
                                                                MenuProps={{
                                                                    variant: "menu",
                                                                    getContentAnchorEl: null,
                                                                    classes: {
                                                                        paper: "custom-select-menu-paper"
                                                                    }
                                                                }}
                                                                className="custom-select"
                                                                disabled={false}
                                                                value={this.state.cancelReasonId || -1}
                                                                onChange={this.handleChange.bind(this)}
                                                            >
                                                                {this.props.cancelReasons &&
                                                                    this.props.cancelReasons.length > 0 &&
                                                                    this.props.cancelReasons.map((cancelReason, i) => {
                                                                        return (
                                                                            <MenuItem
                                                                                key={i}
                                                                                className="form-menu-item-select-multiple"
                                                                                value={cancelReason.id}
                                                                            >
                                                                                <ListItemText
                                                                                    classes={{
                                                                                        root: "form-menu-item-select-multiple-list-item-text"
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        locales[this.props.store[0]][this.props.language].ORDER_PAGE
                                                                                            .CANCEL_SECTION.REASONS[cancelReason.code]
                                                                                    }
                                                                                </ListItemText>
                                                                            </MenuItem>
                                                                        );
                                                                    })}
                                                                )
                                                            </Select>
                                                            {this.state.submitErrors.length > 0 &&
                                                                this.state.submitErrors.find(e => e.code === "cancel_reason") && (
                                                                    <FormHelperText>
                                                                        {this.state.submitErrors.find(e => e.code === "cancel_reason").label}
                                                                    </FormHelperText>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div id="cancel-window-calculation-summary" className="layout vertical cancel-window-calculation-summary">
                                                    <div className="layout horizontal justified">
                                                        <div className="section-title">
                                                            {locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.REFUND_SUMMARY.HEADING}
                                                        </div>
                                                    </div>
                                                    <div className="layout horizontal cancel-window-calculation-summary-breakdown">
                                                        <table className="flex layout vertical ">
                                                            <tbody className="flex layout vertical">
                                                                <tr className="layout horizontal item">
                                                                    <td className="flex layout cancel-window-calculation-summary-label">
                                                                        {`${
                                                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION
                                                                                .REFUND_SUMMARY.ITEMS_SUBTOTAL_TITLE
                                                                        }:`}
                                                                    </td>
                                                                </tr>
                                                                <tr className="layout horizontal item">
                                                                    <td className="flex layout cancel-window-calculation-summary-label">
                                                                        {`${
                                                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION
                                                                                .REFUND_SUMMARY.SHIPPING_TITLE
                                                                        }:`}
                                                                    </td>
                                                                </tr>
                                                                <tr className="layout horizontal item">
                                                                    <td className="flex layout cancel-window-calculation-summary-label">
                                                                        {`${
                                                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION
                                                                                .REFUND_SUMMARY.TAXES_TITLE
                                                                        }:`}
                                                                    </td>
                                                                </tr>

                                                                <tr className={`layout horizontal item refund-total-row`}>
                                                                    <td className="flex layout cancel-window-calculation-summary-label">
                                                                        {`${
                                                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION
                                                                                .REFUND_SUMMARY.REFUND_TOTAL_TITLE
                                                                        }:`}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <table className="layout vertical ">
                                                            <tbody className="flex layout vertical end">
                                                                <tr className="layout horizontal item">
                                                                    <td className="cancel-window-calculation-summary-number">
                                                                        {this.props.cancelOrderCalculateData
                                                                            ? this.props.cancelOrderCalculateData.total_line_items_price_formatted
                                                                            : null}
                                                                    </td>
                                                                </tr>
                                                                <tr className="layout horizontal item">
                                                                    <td className="cancel-window-calculation-summary-number">
                                                                        {this.props.cancelOrderCalculateData
                                                                            ? this.props.cancelOrderCalculateData.total_shipping_formatted
                                                                            : null}
                                                                    </td>
                                                                </tr>
                                                                <tr className="layout horizontal item">
                                                                    <td className="cancel-window-calculation-summary-number">
                                                                        {this.props.cancelOrderCalculateData
                                                                            ? this.props.cancelOrderCalculateData.total_tax_formatted
                                                                            : null}
                                                                    </td>
                                                                </tr>

                                                                <tr className="layout horizontal item refund-total-row">
                                                                    <td className="cancel-window-calculation-summary-number">
                                                                        {this.props.cancelOrderCalculateData
                                                                            ? this.props.cancelOrderCalculateData.total_price_formatted
                                                                            : null}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="sticky-refund-total" className={`sticky-refund-total relative${!this.state.scrolling ? " not-scrolling" : ""}`}>
                                    <div className={`sticky-refund-total-inner-2${!this.state.scrolling ? " not-scrolling" : ""}`} />
                                    <div className="flex layout horizontal end">
                                        <div className="flex layout cancel-window-calculation-summary-label">
                                            {`${
                                                locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.REFUND_SUMMARY.REFUND_TOTAL_TITLE
                                            }:`}
                                        </div>
                                        <div className="cancel-window-calculation-summary-number">
                                            {this.props.cancelOrderCalculateData ? this.props.cancelOrderCalculateData.total_price_formatted : null}
                                        </div>
                                    </div>
                                </div>
                                <div id="buttons-1" className="box">
                                    <div className="row">
                                        <div className="column">
                                            <button className="custom-button" onClick={this.handleNoClick.bind(this)}>
                                                <div className="layout vertical center-center inbutton-text">
                                                    {locales[this.props.store[0]][this.props.language].MISC.CLOSE}
                                                </div>
                                            </button>
                                        </div>
                                        <div className="column">
                                            <button
                                                className={`custom-button ${this.props.loading ? "loading" : ""}`}
                                                style={{ float: "right" }}
                                                onClick={this.props.loading ? null : this.handleYesClick.bind(this)}
                                            >
                                                <div className="layout vertical center-center inbutton-text">
                                                    {locales[this.props.store[0]][this.props.language].MISC.SUBMIT}
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {this.state.cancelFinished && (
                            <div>
                                <div>
                                    <div className="box">
                                        <div className="row">
                                            <div className="column">
                                                <div className="message-box">
                                                    {this.props.cancelOrderCalculateData && this.props.cancelOrderCalculateData.full_order_refund
                                                        ? locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS
                                                              .SUCCESS_MESSAGE_FULL_ORDER
                                                        : locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS
                                                              .SUCCESS_MESSAGE}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box">
                                        <div className="row">
                                            <div className="column">
                                                <button className="custom-button" onClick={this.handleNoClick.bind(this)}>
                                                    <div className="layout vertical center-center inbutton-text">
                                                        {locales[this.props.store[0]][this.props.language].MISC.CLOSE}
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <ConfirmationWindow
                            open={this.state.confirmationWindowOpen}
                            handleClose={this.handleCloseConfirmationWindow.bind(this)}
                            handleSubmit={this.handleConfirmCancelOrder.bind(this)}
                            loading={this.props.loading}
                            heading={locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS.CONFIRMATION.HEADING}
                            subheading={
                                this.props.cancelOrderCalculateData && this.props.cancelOrderCalculateData.full_order_refund
                                    ? locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS.CONFIRMATION
                                          .SUBHEADING_CANCEL_FULL_ORDER
                                    : locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS.CONFIRMATION
                                          .SUBHEADING_CANCEL_ITEMS
                            }
                            noText={locales[this.props.store[0]][this.props.language].MISC.NO}
                            yesText={locales[this.props.store[0]][this.props.language].MISC.YES}
                        />
                        <DataConflictWindow
                            open={this.state.dataConflictWindowOpen}
                            handleSubmit={this.handleRefreshOrder.bind(this)}
                            heading={locales[this.props.store[0]][this.props.language].DATA_CONFLICT.HEADING}
                            subheading={locales[this.props.store[0]][this.props.language].DATA_CONFLICT.SUB_HEADING}
                            yesText={locales[this.props.store[0]][this.props.language].MISC.REFRESH}
                        />
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default withRouter(CancelOrderItemsWindow);



// WEBPACK FOOTER //
// ./src/views/Order/components/_CancelOrderItemsWindow.jsx